export enum CheckoutPages {
  PersonaInfo = 1,
  OrderSummary = 2,
  Payment = 3,
  OrderConfirmation = 4,
}
